import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';

export const performanceReportReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'LOGOUT':
    case 'CLEAR_PERFORMANCE_REPORT':
      return new Map();
    case 'PERFORMANCE_REPORT_EPI_UNIQUES_LOADED':
      return state.set('epis', fromJS(action.data));
    case 'PERFORMANCE_REPORT_PRICES_LOADED':
      return state.set('prices', fromJS(action.data));
    case 'PERFORMANCE_REPORT_PURCHASE_LOADED':
    case 'PERFORMANCE_REPORT_VESSELS_DEALS_LOADED':
      return state.set('purchases', fromJS(action.data));
    case 'PERFORMANCE_REPORT_VESSELS_LOADED':
      return state.set('vessels', fromJS(action.data));
    case 'CLEAR_PERFORMANCE_REPORT_DATA':
      return state.delete('prices').delete('purchases').delete('vessels');
    case 'CLEAR_PERFORMANCE_REPORT_RESULT':
      return state.delete('prices').delete('purchases');
    default:
      return state;
  }
};

export const clearData = (dispatch) => dispatch({ type: 'CLEAR_PERFORMANCE_REPORT_DATA' });
export const clearResult = (dispatch) => dispatch({ type: 'CLEAR_PERFORMANCE_REPORT_RESULT' });
export const clearPerformaceReport = (dispatch) => dispatch({ type: 'CLEAR_PERFORMANCE_REPORT' });


export const getEPIsUniques = (dispatch) => {
  dispatch({ type: 'PERFORMANCE_REPORT_EPI_UNIQUES_LOADING' });
  return RestAPI.get('/pricesdb/api/getUniqueEPI')
    .then(
      (data) => {
        dispatch({ type: 'PERFORMANCE_REPORT_EPI_UNIQUES_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'PERFORMANCE_REPORT_EPI_UNIQUES_LOADING_FAILED' });
        return true;
      },
    );
};

export const getPriceData = (dispatch, product, port, term, from, to) => {
  dispatch({ type: 'PERFORMANCE_REPORT_PRICES_LOADING' });
  return RestAPI
    .get(`/api/report/getPriceHistory?productType=${product}&portGroup=
      ${
  port}&deliveryTerm=${term}&from=${from ? from.toJSON().split('T')[0] : ''}&to=${
  to ? to.toJSON().split('T')[0] : ''}`)
    .then(
      (data) => {
        dispatch({ type: 'PERFORMANCE_REPORT_PRICES_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'PERFORMANCE_REPORT_PRICES_LOADING_FAILED' });
        return true;
      },
    );
};
export const getPurchaseData = (dispatch, product, port, term, allPurchases, from, to) => {
  dispatch({ type: 'PERFORMANCE_REPORT_PURCHASE_LOADING' });
  return RestAPI
    .get(`/api/report/getPerfomancePurchase?productType=${product}&portGroup=
      ${
  port}&deliveryTerm=${term}&allPurchases=${!!allPurchases}&from=${from ?
  from.toJSON().split('T')[0] : ''}&to=${
  to ? to.toJSON().split('T')[0] : ''}`)
    .then(
      (data) => {
        dispatch({ type: 'PERFORMANCE_REPORT_PURCHASE_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'PERFORMANCE_REPORT_PURCHASE_LOADING_FAILED' });
        return true;
      },
    );
};
export const getVessels = (dispatch, product, port, term) => {
  dispatch({ type: 'PERFORMANCE_REPORT_VESSELS_LOADING' });
  return RestAPI
    .get(`/api/report/getPerfomanceTransports?productType=${product}&portGroup=
      ${
  port}&deliveryTerm=${term}`)
    .then(
      (data) => {
        dispatch({ type: 'PERFORMANCE_REPORT_VESSELS_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'PERFORMANCE_REPORT_VESSELS_LOADING_FAILED' });
        return true;
      },
    );
};
export const getVesselDeals = (dispatch, product, port, term, transport) => {
  dispatch({ type: 'PERFORMANCE_REPORT_VESSELS_DEALS_LOADING' });
  return RestAPI
    .get(`/api/report/getPerfomanceTransportDeals?productType=${product}&portGroup=
      ${
  port}&deliveryTerm=${term}&transport=${transport}`)
    .then(
      (data) => {
        dispatch({ type: 'PERFORMANCE_REPORT_VESSELS_DEALS_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'PERFORMANCE_REPORT_VESSELS_DEALS_LOADING_FAILED' });
        return true;
      },
    );
};
